import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React from 'react';
import { ImCheckmark as Check, ImCross as Close } from 'react-icons/im';
import { IStyle } from 'Styles';

interface Props {
  cellEvent: any;
  currentEditingRowId?: number;
  setCurrentEditingRowId?: React.Dispatch<React.SetStateAction<number>>;
  rowSaveHandler?: (...e) => void;
  rowDiscardHandler?: (...e) => void;
  showEditButton: boolean;
}

const ActionButtons = (props: Props) => {
  const {
    cellEvent,
    currentEditingRowId = null,
    setCurrentEditingRowId,
    rowSaveHandler,
    rowDiscardHandler,
    showEditButton,
  } = props;

  const _onClick = (e) => {
    setCurrentEditingRowId(cellEvent.row.index);
  };

  return currentEditingRowId != null && currentEditingRowId === cellEvent.row.index ? (
    <div id="table-actionbuttons-wrapper" className="flex flex-row">
      <RMCustomButton
        Icon={<Check id='table-actionbuttons-check-icon' width={15} height={15} fill={'#24A148'} />}
        onClick={() => rowSaveHandler(cellEvent)}
      />
      <RMCustomButton
        contentContainerStyle={styles.ml1}
        Icon={<Close id='table-actionbuttons-close-icon' width={15} height={15} fill={'#DA1E28'} />}
        onClick={() => {
          rowDiscardHandler(cellEvent);
        }}
      />
    </div>
  ) : showEditButton ? (
    <RMCustomButton
      isDisabled={
        currentEditingRowId != null && currentEditingRowId != cellEvent.row.index
      }
      iconProps={{ name: 'Edit', width: 15, height: 15 }}
      onClick={_onClick}
    />
  ) : null;
};
export default ActionButtons;

const styles: IStyle = {
  ml1: {
    marginLeft: '1rem',
  },
};
